import { DocumentsTable } from '@/components/documents/DocumentsTable'
import { Banner } from '@/components/ui/banner'
import { SkeletonRows } from '@/components/ui/skeleton'
import { useOrgDocuments } from '@/models/document'
import { UploadOtherDocumentsButton } from './UploadOtherDocumentsButton'

/**
 * Every document on the org. Renders the shared DocumentsTable so this modal matches
 * the Documents page rather than growing its own list of the same rows.
 */
export function MyDocumentsSummary({
  orgId,
  readonly,
  underwriting,
}: {
  orgId: string
  readonly?: boolean
  /** The quotes are with underwriters, so an upload now can't change them — and the customer is told so. */
  underwriting?: boolean
}) {
  const { documents, isLoading } = useOrgDocuments(orgId)

  return (
    <div className="flex flex-col gap-4">
      {underwriting && !readonly && (
        <Banner variant="info" small>
          <strong>Underwriting in progress.</strong> Documents you upload now won’t change your active quotes.
        </Banner>
      )}
      {!readonly && (
        <div className="flex justify-end">
          <UploadOtherDocumentsButton orgId={orgId} />
        </div>
      )}
      {isLoading ? <SkeletonRows rows={3} /> : <DocumentsTable documents={documents} readonly={readonly} />}
    </div>
  )
}
